import React, { useEffect, useState } from "react";
import { BsFacebook } from "react-icons/bs";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import api from "../../utils/axios.config";
import { baseUrl } from "../../utils/url";

const DonorPartnerList = () => {
  const [donorPartners, setDonorPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [displayedMembers, setDisplayedMembers] = useState([]);

  // Fetch donor/partner data from backend
  useEffect(() => {
    const fetchDonorPartners = async () => {
      try {
        setLoading(true);
        const response = await api.get("/donor-partner");
        if (response.data.success) {
          setDonorPartners(response.data.donorPartner);
        }
      } catch (error) {
        console.error("Error fetching donor/partner data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDonorPartners();
  }, []);

  // Handle pagination
  useEffect(() => {
    const totalPage = Math.ceil(donorPartners.length / 10);
    if (totalPage > currentPage) {
      setDisplayedMembers(donorPartners.slice(currentPage * 10, 10 * (currentPage + 1)));
    } else if (totalPage > 0) {
      setCurrentPage(0);
    }
  }, [currentPage, donorPartners]);

  const handleIncreasePage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handleDecreasePage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading) {
    return (
      <div className="m-2 md:m-5 flex justify-center items-center min-h-screen">
        <p className="text-xl">লোড হচ্ছে...</p>
      </div>
    );
  }

  return (
    <div className="m-2 md:m-5">
      <h3 className="text-center font-bold text-2xl">ডোনার এন্ড পার্টনার</h3>
      <div className="my-2 flex justify-end">
        <input
          type="text"
          placeholder="মোবাইল নাম্বার লিখুন"
          className="input input-bordered input-md w-full max-w-xs"
        />
        <button className="btn bg-secondary text-white border-0 mx-2">
          অনুসন্ধান
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-compact w-full">
          <thead>
            <tr>
              <th className="bg-secondary text-white">নাম এবং পদবী</th>
              <th className="bg-secondary text-white">
                কর্মরত প্রতিষ্ঠানের নাম এবং পদবী
              </th>
              <th className="bg-secondary text-white">যোগাযোগ</th>
              <th className="bg-secondary text-white">ঠিকানা</th>
              <th className="bg-secondary text-white">ফেসবুক</th>
            </tr>
          </thead>
          <tbody>
            {displayedMembers?.map((member, index) => (
              <tr key={member._id || index}>
                <td>
                  <div className="flex items-center space-x-3">
                    <div className="avatar">
                      <div className="mask mask-squircle w-20 h-20 p-2">
                        {member?.imageUrl && (
                          <div className="avatar">
                            <div className="mask mask-squircle w-20 h-20">
                              <img
                                src={`${baseUrl.replace('/api/v1/', '')}${member?.imageUrl}`}
                                alt={member?.name || "Donor/Partner"}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="font-bold">{member?.name}</div>
                      <div className="text-sm opacity-80">{member?.designation}</div>
                    </div>
                  </div>
                </td>

                <td>
                  <div className="font-bold">{member?.institute}</div>
                </td>
                <td>
                  {member?.emailUrl && (
                    <div className="text-sm opacity-80">{member?.emailUrl}</div>
                  )}
                </td>
                <td>-</td>
                <td>
                  {member?.facebookUrl && (
                    <a
                      href={member?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <BsFacebook color="blue" size={30} />
                    </a>
                  )}
                  {member?.webUrl && (
                    <a
                      href={member?.webUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ml-2 text-blue-500"
                    >
                      Website
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {donorPartners.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-lg">কোন ডোনার বা পার্টনার পাওয়া যায়নি</p>
          </div>
        ) : (
          <div className="px-5">
            <div className="flex justify-end items-center">
              <div className="px-6 py-4">
                {currentPage * 10 + 1}-{Math.min(10 * (currentPage + 1), donorPartners.length)} of{" "}
                {donorPartners?.length}
              </div>
              <div>
                <div className="flex items-center">
                  <button className="pr-10" onClick={handleDecreasePage}>
                    <MdOutlineKeyboardArrowLeft />
                  </button>
                  <button onClick={handleIncreasePage}>
                    <MdOutlineKeyboardArrowRight />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DonorPartnerList;
